'use client';

import { ElementRef } from 'react';
import type { ComponentProps } from 'react';
import { PanelLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSidebar } from './context';

export const SidebarTrigger = ({
  ref,
  onClick,
  ...props
}: ComponentProps<typeof Button> & {
  ref?: React.RefObject<ElementRef<typeof Button> | null>;
}) => {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      ref={ref}
      data-sidebar="trigger"
      variant="ghost"
      size="icon-2xs"
      // VALE-1202 debt: the 24px square is now `size`, but this grey is a raw
      // `--grey-45` rather than a semantic token, so it has no `tone` step to
      // move to. It converts when the sidebar tranche picks up a token.
      className="text-[var(--grey-45)]"
      onClick={(event) => {
        onClick?.(event);
        toggleSidebar();
      }}
      {...props}
    >
      <PanelLeft className="h-4 w-4" />
      <span className="sr-only">Toggle Sidebar</span>
    </Button>
  );
};
SidebarTrigger.displayName = 'SidebarTrigger';
